import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { useHistory } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import './styles.css';
import api from '../../services/api';

import FeedLayout from '../Includes/FeedLayout';
import perfil from '../../assests/perfil.jpg';
import { calculaTempo } from '../../global';

const BASE_URL = sessionStorage.getItem('BASE_URL');
const USER_EMAIL = sessionStorage.getItem('email');
const USER_TOKEN = sessionStorage.getItem('token');


export default function MeusanunciosDetalhe(props) {
  const { t } =  useTranslation();
  const history = useHistory();
  const anuncio_id = props.match.params.id;
  const [title, setTitle] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [annoucement_time, setAnnoucement_time] = useState(15);
  const [tag, setTag] = useState('');
  const [tagAn, setTagAn] = useState(pegarTag);
  const [upload, setUpload] = useState(['']);
  const [urlimg, setUrlimg] = useState('');
  const [phone, setPhone] = useState('');
  const [city_code, setCity_code] = useState(0);
  const [state_code, setState_code] = useState(0);
  const [cidades, setCidades] = useState(['']);
  const [nomeCidade, setNomeCidade] = useState('');
  const [livestock_race, setLivestock_race] = useState('');
  const [count, setCount] = useState(0.0);
  const [livestock_age, setLivestock_age] = useState(0);
  const [livestock_weight, setLivestock_weight] = useState(0);
  const [value, setValue] = useState(0);
  const [count_type, setCount_type] = useState('fifteen_kilos');
  const [obs, setObs] = useState('');
  const [erros, setErros] = useState(['']);
  const [original_image_url, setOriginal_image_url] = useState('');
  const [user_info, setUser_info] = useState(['']);
  const [created_at, setCreated_at] = useState('');
  const [city_info, setCity_info] = useState(['']);
  const [state_info, setState_info] = useState(['']);

  function pegarTag() {
    var tags = JSON.parse(sessionStorage.getItem('TAGS'));
    var tagAnuncio = [];

    tags.forEach(tag => {
      if (tag.is_bovine === true) {
        var arr = { 'id': tag.id, 'name': tag.name, 'slug': tag.slug }
        tagAnuncio.push(arr);
      }
    });
    return tagAnuncio;
  }

  useEffect(() => {
    api.get(`/v6/classifieds/${anuncio_id}`, {
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      }
    }).then(response => {
      setTitle(response.data.title);
      setMensagem(response.data.description);
      setAnnoucement_time(response.data.annoucement_time);
      setTag(response.data.category);
      setUrlimg(response.data.original_image_url);
      setPhone(response.data.phone);
      setCity_code(response.data.city_info.code);
      setNomeCidade(response.data.city_info.name + ', ' + response.data.state_info.acronym);
      setLivestock_race(response.data.livestock_race);
      setCount(response.data.count);
      setLivestock_age(response.data.livestock_age);
      setLivestock_weight(response.data.livestock_weight);
      setValue(response.data.value);
      setCount_type(response.data.count_type);
      setObs(response.data.observation);
      setState_code(response.data.state_info.code);
      setOriginal_image_url(response.data.original_image_url);
      setUser_info(response.data.user_info);
      setCreated_at(response.data.created_at);
      setCity_info(response.data.city_info);
      setState_info(response.data.state_info);
    }).catch(function (error) {
      setErros(error.response.data.errors);
      //mostrarErros();
    })
  }, [annoucement_time, anuncio_id, props.match.params.id])
  function mascaraTel(e) {
    if (e.length > 2) {
      e = e.replace(/\D/g, "");
      e = e.replace(/^(\d{2})(\d)/g, "($1) $2");
    }
    setPhone(e);
  }
  function limpaTelefone(phone) {
    var v = phone.replace("(", "");
    v = v.replace(")", "");
    v = v.replace(" ", "");
    setPhone(v);
  }

  function mostrarErros() {
    let msg = document.getElementById('msg');
    msg.style.display = 'block';
    setTimeout(() => {
      msg.style.display = 'none';
    }, 5000)
  }
  function mostrarSuccess() {
    let msg = document.getElementById('success');
    msg.style.display = 'block';
    let btn = document.getElementById('btn-enviar');
    btn.disabled = true;

    setTimeout(() => {
      msg.style.display = 'none';
      history.push('/meus-anuncios')
    }, 5000)
  }

  function enviarAnuncio(event) {
    event.preventDefault();
    if (!document.getElementById('fileInput').files[0] && !urlimg) {
      setErros([ t('pages.announcementDetails.messages.errors.insertAPicture') ]);
      mostrarErros();
      return false;
    }
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();
    data.append('title', title);
    data.append('description', mensagem);
    data.append('phone', phone);
    data.append('category', tag);
    data.append('value', value);
    data.append('observation', obs);
    data.append('has_video', 'true');
    if (document.getElementById('fileInput').files[0]) {
      data.append('image', document.getElementById('fileInput').files[0]);
    }
    data.append('image_url', urlimg);
    data.append('original_image_url', original_image_url);
    data.append('annoucement_time', annoucement_time);
    data.append('count', count);
    data.append('count_type', count_type);
    data.append('livestock_weight', livestock_weight);
    data.append('livestock_race', livestock_race);
    data.append('livestock_age', livestock_age);
    data.append('city_code', city_code);
    data.append('state_code', state_code);
    var config = {
      method: 'put',
      url: BASE_URL + `/v6/classifieds/${anuncio_id}`,
      headers: {
        'USER_EMAIL': sessionStorage.getItem('email'),
        'USER_TOKEN': sessionStorage.getItem('token'),
        //...data.getHeaders()
      },
      data: data
    };
    axios(config)
      .then(function (response) {
        mostrarSuccess();
        setTimeout(() => {
          //history.push(`/negociacoes/${this.state.id}`)
          //window.location = `/meus-anuncios`;
        }, 5000);
      })
      .catch(function (error) {
        setErros(error.response.data.errors);
        mostrarErros();
      })
  }
  function Select(props) {
    return (
      <select id="tag_id"
        onChange={e => setTag(e.target.value)}
        value={tag}
      >
        <option value="0"> { t('pages.announcementDetails.placeholders.tags') } </option>
        {
          tagAn.map(tag => (
            <option value={tag.slug} select>{tag.name}</option>
          ))
        }
      </select>
    )
  }
  async function SelectCidade(city) {
    let data = new FormData();
    if (city.length >= 3) {
      await api.get(`/v4/search/cities?term=${city}`, {
        headers: {
          ...data.getHeaders
        }
      }, data).then(function (response) {
        setCidades(response.data);
        document.getElementById("dvCidades").style.display = "block";
      })
    }
  }
  function minhaCidade(id, nome) {
    var cid = id.toString();
    var state = cid.substring(0, 2);
    setCity_code(id);

    setNomeCidade(nome);
    setState_code(state);
    document.getElementById("dvCidades").style.display = "none";
  }
  function AtualizaImagem(e) {
    // const contentType = 'image/jpeg';
    // const blob = new Blob([e]);
    // const blobURL = URL.createObjectURL(blob, {contentType: contentType});
    // setUrlimg(blobURL);
  }
  function pegarValorTextArea(id, value) {
    alert(value);
    // var textArea = document.getElementById(id).value;
    // alert(textArea);
    // setMensagem(textArea);
    // document.getElementById(id).value = mensagem;
  }
  function tipo_contagem(tipo) {
    switch (tipo) {
      case 'fifteen_kilos': {
        return t('pages.announcementDetails.fifteenKilos');
      }
      case 'sacs': {
        return t('pages.announcementDetails.sacs');
      }
      case 'tons': {
        return t('pages.announcementDetails.tons');
      }
      case 'head': {
        return t('pages.announcementDetails.head');
      }
      default: {
        return t('pages.announcementDetails.liveKilos')
      }
    }
  }
  function voltar(){
    const from = sessionStorage.getItem('adFrom');
    if (from === 'classifieds') {
      history.push('/classificados');
    } else if (from === 'timeline') {
      history.push('/timeline');
    } else {
      history.push('/meus-anuncios');
    }
  }

  function urlWhats(phone) {
    return 'https://api.whatsapp.com/send?phone=' + phone;
  }
  return (
    <FeedLayout active={sessionStorage.getItem('adFrom') === 'classifieds' ? 'classifieds' : (sessionStorage.getItem('adFrom') === 'timeline' ? 'timeline' : 'profile')}>
    <div className="meusanunciosdet-container">
      <div className="feed-top">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.announcementDetails.back')}
        </button>
        <span className="feed-top-title">{title || t('pages.includes.filters.classified')}</span>
      </div>
      <section className="body">
        <ul>
          <li key={props.match.params.id}>
            <p className="nomeProf"><img className="imgProf" src={(!user_info.avatar || user_info.avatar.medium === null) ? perfil : user_info.avatar.medium} alt="Perfil" /><span className="nome">{user_info.name}</span><span className="tempo">  -  {calculaTempo(created_at)}</span></p>
            <p className="tags">
              <span>#{tag}</span>
            </p>
            <div className="titulo">
              <p>{Intl.NumberFormat('pt-BR', { style: 'currency', currency: "BRL", minimumFractionDigits: 2 }).format(value)}</p>
            </div>
            <div className="campos">
              <img src={urlimg} class="preview-img" alt="img" />
            </div>
            <div className="titulo">
              <h5>{(city_info && city_info.name) || ''}{(city_info && city_info.name && state_info && state_info.acronym) ? ', ' : ''}{(state_info && state_info.acronym) || ''}</h5>
            </div>
            <div className="titulo">
              <h3>{mensagem}</h3>
            </div>
            <div className="titulo">
              <a target="_blank" href={urlWhats(phone)}><FaWhatsapp></FaWhatsapp>{phone}</a>
            </div>
            <div><hr /></div>

            <div className="titulo">
              <h3>{t('pages.announcementDetails.breed')}<span>{livestock_race}</span></h3>
            </div>
            <div className="titulo">
              <h3>{t('pages.announcementDetails.age')}<span>{livestock_age}</span></h3>
            </div>
            <div className="titulo">
              <h3>{t('pages.announcementDetails.weightKG')}<span>{livestock_weight}</span></h3>
            </div>
            <div className="titulo">
              <h3>{t('pages.announcementDetails.heads')}<span>{count}</span></h3>
            </div>
            <div className="titulo">
              <h3>{t('pages.announcementDetails.price')}<span>{Intl.NumberFormat('pt-BR', { style: 'currency', currency: "BRL", minimumFractionDigits: 2 }).format(value)} {tipo_contagem(count_type)}</span></h3>
            </div>
            <div className="titulo">
              <h3>{t('pages.announcementDetails.observation')}<span>{obs}</span></h3>
            </div>
          </li>
        </ul>
      </section>
      <section className="paginacao">
        <button type="button" className="btn-voltar" onClick={voltar}>
          <FiArrowLeft size={18} /> {t('pages.announcementDetails.back')}
        </button>
      </section>
    </div>
    </FeedLayout>
  )
}